// Libraries
import React, { ChangeEvent, useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

// Hooks
import { useForm } from 'react-hook-form'

// Styles
import { FakeRow } from '../../layouts/MainWrapperWithCaptions/style'
import { Check, StyledCheckBox, StyledLabel, StyledSpan } from '../../ui/CheckBox/style'

// Layouts
import { Input } from '../../ui/Input/index'
import { Button } from '../../ui/Button'
import { ArrowLeft, TextButton } from '../../ui/TextButton'
import { MainWrapperWithCaptions } from '../../layouts/MainWrapperWithCaptions'
import Progress from '../../components/Progress'
import { TextDescription, WrapFormContent } from './WrapFormContent'
import { ErrorText, WrapInput } from '../../ui/Input/style'

interface IProps {
  setStageAndToTop: (arg0: number) => void;
  appendData: (arg0: object) => void;
  currentStage: number;
}

interface IFormInputs {
  email: string;
}

const SignupSchema = yup
  .object({
    email: yup.string().email('Email ist ungültig').required('Dieses Feld ist erforderlich'),
  })
  .required();


export const StageOne = ({ currentStage, setStageAndToTop, appendData  }: IProps) => {
  const { register: emailRegister, handleSubmit: emailHandleSubmit, reset: emailReset, formState: { errors } } = useForm<IFormInputs>({
    resolver: yupResolver(SignupSchema)
  })


  const [isChecked, setIsChecked] = useState(false)
  const [isCheckBoxError, setIsCheckBoxError] = useState(false)

  let initialSubmit = true;
  const onEmailSubmit = (body: object) => {
    if(initialSubmit) {
      setIsCheckBoxError(isChecked ? false : true)
      if(!isChecked) {
        initialSubmit = false
        return
      }
      setIsCheckBoxError(false)
      appendData(body)
      emailReset()
      setStageAndToTop(2)
    }
    if(isCheckBoxError && !isChecked) return
    setIsCheckBoxError(false)
    appendData(body)
    emailReset()
    setStageAndToTop(2)
  }

  const handleCheckBoxChange = (event: ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked)
    setIsCheckBoxError(event.target.checked ? false : true)
  }

  return (
    <>
      <FakeRow>
        <MainWrapperWithCaptions stage={currentStage}
                                 title='Jetzt starten'
                                 description={<>Bitte gib hier Deine<br />Email-Adresse ein</>}
                                 key={1}
                                 textAlign='left'>
          <Progress stage={currentStage} />
        </MainWrapperWithCaptions>
      </FakeRow>
      <WrapFormContent onSubmit={emailHandleSubmit(onEmailSubmit)}>
        <WrapInput>
          <Input placeholder='Email-Adresse' {...emailRegister('email')} errorMessage={errors?.email?.message}  isError={errors?.email !== undefined} />
        </WrapInput>
        <StyledLabel $isError={isCheckBoxError}>
          <StyledCheckBox
            onChange={handleCheckBoxChange}
            checked={isChecked}
          />
          <StyledSpan aria-hidden='true' onClick={ () => {} }>
            {isChecked && <Check src='/asterisk.svg'
                                 initial={{ scale: 0 }}
                                 animate={{ scale: 1 }}
                                 exit={{ scale: [1.2, 0] }}
                                 transition={{ duration: .1 }}/>}
          </StyledSpan>
          *Morbi sed bibendum ut commodo lorem. Viverra malesuada sit sed ut amet quam mi.
        </StyledLabel>
        <Button arrow>Weiter</Button>
        <TextDescription>
          Arcu vivamus amet, ac quam viverra sapien ac posuere semper. Massa elementum libero lacus, volutpat vestibulum.
        </TextDescription>
        <TextButton onClick={() => setStageAndToTop(0)}>
          <ArrowLeft width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 1L0.999999 10.5L9 20" stroke="white" strokeWidth="1.5"/>
          </ArrowLeft>
          Zurück
        </TextButton>
      </WrapFormContent>
    </>
  )
}